import { db } from '../firebase';
import { 
  collection, 
  doc,
  addDoc,
  getDocs,
  getDoc,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';

export const bookService = {
  // Get all available books from the catalog
  async getBookCatalog() {
    try {
      const booksRef = collection(db, 'books');
      const q = query(booksRef, orderBy('title'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting book catalog:', error);
      throw error;
    }
  },

  // Get user's library with full book details
  async getUserLibrary(userId) {
    try {
      const libraryRef = collection(db, 'userLibrary');
      const q = query(
        libraryRef,
        where('userId', '==', userId),
        orderBy('addedAt', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      const libraryItems = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Fetch full book details for each library item
      const libraryWithDetails = await Promise.all(
        libraryItems.map(async (item) => {
          const bookDoc = await getDoc(doc(db, 'books', item.bookId));
          const bookData = bookDoc.data();
          return {
            ...item,
            ...bookData,
            libraryId: item.id, // Keep the library document ID
            progress: item.progress || 0,
            status: item.status || 'want-to-read'
          };
        })
      );

      return libraryWithDetails;
    } catch (error) {
      console.error('Error getting user library:', error);
      throw error;
    }
  },

  // Add book to user's library
  async addToLibrary(userId, bookId, status = 'want-to-read') {
    try {
      const libraryRef = collection(db, 'userLibrary');
      await addDoc(libraryRef, {
        userId,
        bookId,
        status,
        progress: 0,
        addedAt: serverTimestamp(),
        startedAt: null,
        completedAt: null,
        notes: ''
      });
    } catch (error) {
      console.error('Error adding book to library:', error);
      throw error;
    }
  },

  // Update book status and progress
  async updateBookProgress(libraryItemId, updates) {
    try {
      const bookRef = doc(db, 'userLibrary', libraryItemId);
      await updateDoc(bookRef, {
        ...updates,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating book progress:', error);
      throw error;
    }
  }
}; 